import Client from "../../api/commonApi";


/*
  REACT_APP_API_ROUTE_SURVEY 문자열음 "/"붙여서 시작한다.
  Backend API에서 // 문자열을 인식하지 못하여서 URL 문자열 수정 적용
  REACT_APP_API_ROUTE_ASSESSMENT 커피 평가 결과 조회 (커피키)
*/
const request_host = `${process.env.REACT_APP_API_ROUTE_SURVEY}`;
const route_survey_assessment = process.env.REACT_APP_API_ROUTE_ASSESSMENT;

/* 
  커피키로 커피 평가 결과 조회
  커피키 :: d063db2d-4fe4-41f3-889a-556dea673987 일때
  /survey/coffeeKey/d063db2d-4fe4-41f3-889a-556dea673987
*/
const fetchSurveyCoffeeKey = async (CoffeeKey) => {
    return Client.get(`${request_host}/${route_survey_assessment}/${CoffeeKey}`, { CoffeeKey });
};

const fetchSurveyResult = async (mainId) => {
    return Client.get(`${request_host}/result/${mainId}`, { mainId });
};

const postSurveyResult = async (mainId, participantId) => {
    return Client.get(`${request_host}/result/${mainId}/${participantId}`, { mainId, participantId});
};


export {
    fetchSurveyCoffeeKey, fetchSurveyResult, postSurveyResult
};